import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { DustExZoneType } from "@domain/project/floorplan/zones/dust-ex-zone";
import { FloorplanZonesService } from "@project/floorplan-zones.service";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-dust-ex-zone-menu",
  imports: [
    FloorplanMenuItemButtonsComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    UiKitModule,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./floorplan-dust-ex-zone-menu.component.html",
  styleUrl: "./floorplan-dust-ex-zone-menu.component.scss",
})
export class FloorplanDustExZoneMenuComponent {
  private floorplanService = inject(FloorplanService);
  private floorplanZonesService = inject(FloorplanZonesService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;
  protected readonly DustExZoneType = DustExZoneType;
  protected readonly tooltipTextAddDustExZone = (type: number) =>
    $localize`:@@floorplan.button.addDustExZone:Staub-Ex-Zone 2${type}:dustExZoneType: platzieren`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addDustExZone(zoneType: DustExZoneType) {
    this.floorplanZonesService.addDustExZone(zoneType);
  }

  protected dragDustExZone(zoneType: DustExZoneType) {
    this.dragDropService.setDragged({ type: DraggedItemType.DUST_EX_ZONE, config: zoneType });
  }

  protected updateDustExZonesItemTextVisibility(visible: boolean) {
    this.floorplanState.updateDustExZonesItemTextVisibility(visible);
  }
}
